import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import { ObservationUnitListResponse } from '../model/observationUnitListResponse';
import { SERVER_API_URL } from '../../app.constants';
import { ObservationUnitSingleResponse } from '../model/observationUnitSingleResponse';

@Injectable()
export class ObservationUnitsService {

    public defaultHeaders = new HttpHeaders();

    constructor(protected httpClient: HttpClient) {
    }

    public observationunitsGet(cropName: string, params: ObservationUnitGetParams, observe?: 'body'): Observable<ObservationUnitListResponse>;
    public observationunitsGet(cropName: string, params: ObservationUnitGetParams, observe?: 'response'): Observable<HttpResponse<ObservationUnitListResponse>>;
    public observationunitsGet(cropName: string, params: ObservationUnitGetParams, observe?: 'events'): Observable<HttpEvent<ObservationUnitListResponse>>;
    public observationunitsGet(cropName: string, params: ObservationUnitGetParams, observe: any = 'body'): Observable<any> {

        let queryParameters = new HttpParams();
        if (params.observationUnitDbId !== undefined && params.observationUnitDbId !== null) {
            queryParameters = queryParameters.set('observationUnitDbId', <any>params.observationUnitDbId);
        }
        if (params.observationUnitName !== undefined && params.observationUnitName !== null) {
            queryParameters = queryParameters.set('observationUnitName', <any>params.observationUnitName);
        }
        if (params.locationDbId !== undefined && params.locationDbId !== null) {
            queryParameters = queryParameters.set('locationDbId', <any>params.locationDbId);
        }
        if (params.seasonDbId !== undefined && params.seasonDbId !== null) {
            queryParameters = queryParameters.set('seasonDbId', <any>params.seasonDbId);
        }
        if (params.includeObservations !== undefined && params.includeObservations !== null) {
            queryParameters = queryParameters.set('includeObservations', <any>params.includeObservations);
        }
        if (params.observationUnitLevelName !== undefined && params.observationUnitLevelName !== null) {
            queryParameters = queryParameters.set('observationUnitLevelName', <any>params.observationUnitLevelName);
        }
        if (params.observationUnitLevelOrder !== undefined && params.observationUnitLevelOrder !== null) {
            queryParameters = queryParameters.set('observationUnitLevelOrder', <any>params.observationUnitLevelOrder);
        }
        if (params.observationUnitLevelCode !== undefined && params.observationUnitLevelCode !== null) {
            queryParameters = queryParameters.set('observationUnitLevelCode', <any>params.observationUnitLevelCode);
        }
        if (params.observationUnitLevelRelationshipName !== undefined && params.observationUnitLevelRelationshipName !== null) {
            queryParameters = queryParameters.set('observationUnitLevelRelationshipName', <any>params.observationUnitLevelRelationshipName);
        }
        if (params.observationUnitLevelRelationshipOrder !== undefined && params.observationUnitLevelRelationshipOrder !== null) {
            queryParameters = queryParameters.set('observationUnitLevelRelationshipOrder', <any>params.observationUnitLevelRelationshipOrder);
        }
        if (params.observationUnitLevelRelationshipCode !== undefined && params.observationUnitLevelRelationshipCode !== null) {
            queryParameters = queryParameters.set('observationUnitLevelRelationshipCode', <any>params.observationUnitLevelRelationshipCode);
        }
        if (params.observationUnitLevelRelationshipDbId !== undefined && params.observationUnitLevelRelationshipDbId !== null) {
            queryParameters = queryParameters.set('observationUnitLevelRelationshipDbId', <any>params.observationUnitLevelRelationshipDbId);
        }
        if (params.commonCropName !== undefined && params.commonCropName !== null) {
            queryParameters = queryParameters.set('commonCropName', <any>params.commonCropName);
        }
        if (params.programDbId !== undefined && params.programDbId !== null) {
            queryParameters = queryParameters.set('programDbId', <any>params.programDbId);
        }
        if (params.trialDbId !== undefined && params.trialDbId !== null) {
            queryParameters = queryParameters.set('trialDbId', <any>params.trialDbId);
        }
        if (params.studyDbId !== undefined && params.studyDbId !== null) {
            queryParameters = queryParameters.set('studyDbId', <any>params.studyDbId);
        }
        if (params.germplasmDbId !== undefined && params.germplasmDbId !== null) {
            queryParameters = queryParameters.set('germplasmDbId', <any>params.germplasmDbId);
        }
        if (params.externalReferenceID !== undefined && params.externalReferenceID !== null) {
            queryParameters = queryParameters.set('externalReferenceID', <any>params.externalReferenceID);
        }
        if (params.externalReferenceId !== undefined && params.externalReferenceId !== null) {
            queryParameters = queryParameters.set('externalReferenceId', <any>params.externalReferenceId);
        }
        if (params.externalReferenceSource !== undefined && params.externalReferenceSource !== null) {
            queryParameters = queryParameters.set('externalReferenceSource', <any>params.externalReferenceSource);
        }
        if (params.page !== undefined && params.page !== null) {
            queryParameters = queryParameters.set('page', <any>params.page);
        }
        if (params.pageSize !== undefined && params.pageSize !== null) {
            queryParameters = queryParameters.set('pageSize', <any>params.pageSize);
        }

        let headers = this.defaultHeaders;
        if (params.authorization !== undefined && params.authorization !== null) {
            headers = headers.set('Authorization', String(params.authorization));
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<ObservationUnitListResponse>('get', `${SERVER_API_URL}${cropName}/brapi/v2/observationunits`,
            {
                params: queryParameters,
                headers,
                observe: observe || 'body',
                reportProgress: params.reportProgress || false
            }
        );
    }

    public observationunitPatch(cropName: string, observationUnitDbId: string, body?: any, observe?: 'body', reportProgress?: boolean): Observable<ObservationUnitSingleResponse>;
    // tslint:disable-next-line:max-line-length
    public observationunitPatch(cropName: string, observationUnitDbId: string, body?: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObservationUnitSingleResponse>>;
    // tslint:disable-next-line:max-line-length
    public observationunitPatch(cropName: string, observationUnitDbId: string, body?: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObservationUnitSingleResponse>>;
    public observationunitPatch(cropName: string, observationUnitDbId: string, body?: any, observe: any = 'body', reportProgress = false): Observable<any> {

        if (observationUnitDbId === null || observationUnitDbId === undefined) {
            throw new Error('Required parameter observationUnitDbId was null or undefined when calling observationunitsObservationUnitDbIdPut.');
        }

        const headers = this.defaultHeaders;

        return this.httpClient.request<ObservationUnitSingleResponse>('patch',
            `${SERVER_API_URL}${cropName}/brapi/v2/observationunits/${encodeURIComponent(String(observationUnitDbId))}`,
            {
                body,
                headers,
                observe,
                reportProgress
            }
        );
    }

    public observationunitsPatch(cropName: string, body?: any, observe?: 'body', reportProgress?: boolean): Observable<ObservationUnitSingleResponse>;
    // tslint:disable-next-line:max-line-length
    public observationunitsPatch(cropName: string, body?: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ObservationUnitSingleResponse>>;
    // tslint:disable-next-line:max-line-length
    public observationunitsPatch(cropName: string, body?: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ObservationUnitSingleResponse>>;
    public observationunitsPatch(cropName: string, body?: any, observe: any = 'body', reportProgress = false): Observable<any> {

        const headers = this.defaultHeaders;

        return this.httpClient.request<ObservationUnitSingleResponse>('patch',
            `${SERVER_API_URL}${cropName}/brapi/v2/observationunits`,
            {
                body,
                headers,
                observe,
                reportProgress
            }
        );
    }
}

interface ObservationUnitGetParams {
    observationUnitDbId?: string;
    observationUnitName?: string;
    locationDbId?: string;
    seasonDbId?: string;
    includeObservations?: boolean;
    observationUnitLevelName?: string;
    observationUnitLevelOrder?: string;
    observationUnitLevelCode?: string;
    observationUnitLevelRelationshipName?: string;
    observationUnitLevelRelationshipOrder?: string;
    observationUnitLevelRelationshipCode?: string;
    observationUnitLevelRelationshipDbId?: string;
    commonCropName?: string;
    programDbId?: string;
    trialDbId?: string;
    studyDbId?: string;
    germplasmDbId?: string;
    externalReferenceID?: string;
    externalReferenceId?: string;
    externalReferenceSource?: string;
    page?: number;
    pageSize?: number;
    authorization?: string;
    reportProgress?: boolean;
}
